import Immutable from 'immutable'
import * as types from '../constants/LotteryActionTypes'

const initialState = Immutable.Map({
	selected: null,
	lotteries: null
})

function receiveLotteries(state, lotteries){
	return state.set('lotteries', Immutable.fromJS(lotteries));	
}

function selectLottery(state, lottery){
	return state.set('selected', lottery);	
}

export default function lotteries (state = initialState, action) {
  switch (action.type) {
  	case types.RECEIVE_LOTTERIES:
  		return receiveLotteries(state, action.lotteries);
  	case types.SELECT_LOTTERY:
  		return selectLottery(state, action.lottery);
    default:
      return state;
  }
}
